import { useEffect, useState } from "react";
import axios from "axios";
//import { useNavigate } from "react-router-dom"; // za navigaciju ka edit formi

function KatalogView({ onEdit }) { // prima onEdit iz Admin panela
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");

  const loadItems = async () => {
    const res = await axios.get("http://localhost:5000/api/katalog");
    setItems(res.data);
  };

  const deleteItem = async (id) => {
    if (!window.confirm("Obrisati item?")) return;
    await axios.delete(`http://localhost:5000/api/katalog/${id}`);
    loadItems();
  };

  useEffect(() => { loadItems(); }, []);

  const filteredItems = items.filter(item =>
    item.Naslov.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <h3>Katalog</h3>

      <input
        type="text"
        placeholder="Pretraga..."
        className="form-control mb-3"
        value={search}
        onChange={e => setSearch(e.target.value)}
      />

      <table className="table table-striped">
        <thead>
          <tr>
            <th>Slika</th>
            <th>Naslov</th>
            <th>Opis</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {filteredItems.map(item => (
            <tr key={item.ItemID}>
              <td>
                <img
                  src={`http://localhost:5000${item.Image}`}
                  alt={item.Naslov}
                  width="80"
                />
              </td>
              <td>{item.Naslov}</td>
              <td>{item.opis}</td>
              <td>
                <button
                  className="btn btn-primary btn-sm me-2"
                  onClick={() => onEdit(item.ItemID)} // poziva Admin panel
                >
                  Edit
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => deleteItem(item.ItemID)}
                >
                  Obriši
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default KatalogView;